import type { WllTheme } from './types'

export const lightTheme: WllTheme = {
	background: 'bg-white',
	border: 'border-gray-300',
	primary: 'text-gray-900',
	secondary: 'text-gray-700',
}

export const darkTheme: WllTheme = {
	background: 'bg-gray-800',
	border: 'border-grey-700',
	primary: 'text-grey-50',
	secondary: 'text-grey-300',
}
